import React from 'react'
import styles from '@bt-react/styles'
import { Input } from 'reactstrap'
import { TextareaProps } from './types'

export default class Textarea extends React.Component<TextareaProps> {

  render () {

    if (this.props.reducedAsscessUserRole && this.props.readOnly) {

      return (
        <div
          data-bdd={this.props.dataBdd || 'textarea'}>
          {this.props.value}
        </div>
      )

    }

    return (
      <Input
        innerRef={this.props.innerRef}
        data-bdd={this.props.dataBdd || 'textarea'}
        type="textarea"
        disabled={this.props.disabled}
        className={this.props.className}
        onChange={({ target }) => {

          this.props.onChange && this.props.onChange(this.props?.id ?? '', target.value)

        }}
        onKeyPress={this.props.onKeyPress}
        onBlur={({ target }) => {

          if (this.props.onBlur) this.props.onBlur(this.props?.id ?? '')

        }}
        onFocus={(ev) => {

          this.props.onFocus && this.props.onFocus(ev)

        }}
        id={this.props.id}
        onClick={this.props.onClick}
        value={this.props.value}
        placeholder={this.props.placeholder}
        cssModule={styles}
        invalid={!!(this.props.error)}
        name={this.props.name}
        autoFocus={this.props.autoFocus}
      />
    )

  }

}
